import React from "react";
import classNames from "classnames";
import { useDrag } from "react-dnd";
import tinycolor from "tinycolor2";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";

import Address from "../../shared/Address";
import styles from "./AvailableBids.css";

export const DraggableType = "bid";

const shouldDisable = (_, activeCrew) => !!activeCrew;

const makeStyle = ({ color }) =>
  !color
    ? null
    : {
        backgroundColor: color,
        borderColor: tinycolor(color).darken(40),
        color: tinycolor(color).getBrightness() < 150 ? "#fff" : "#000",
      };

const Bid = ({ activeCrew, detailEnabled, bid, locationEnabled, onClick }) => {
  const disable = shouldDisable(bid, activeCrew);
  const [, drag] = useDrag({
    item: { bidId: bid.id, bid, type: DraggableType },
  });
  return (
    <div
      className={classNames(styles.bid, { [styles.disabled]: disable })}
      onDoubleClick={disable ? null : onClick}
      ref={drag}
      style={makeStyle(bid)}
    >
      <div>
        <div style={makeStyle(bid)}>
          <h5
            style={{
              textAlign: "left",
              padding: "6px 8px",
              fontSize: "16px",
              fontFamily: "var(--font-family-Fira-Condensed)",
              margin: 0,
            }}
          >
            <b>{bid.name}</b>
          </h5>
        </div>
        <div
          className={styles.bidHeader}
          style={{ padding: "0px 8px 8px 8px" }}
        >
          {bid.location && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Location
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {bid.location}
              </FormControl.Static>
            </FormGroup>
          )}

          {bid.office && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Office
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {bid.office.name}
              </FormControl.Static>
            </FormGroup>
          )}

          {locationEnabled && <Address address={bid.address} styles={styles} />}

          {detailEnabled && bid.salesperson && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Salesperson
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {bid.salesperson.firstName} {bid.salesperson.lastName}
              </FormControl.Static>
            </FormGroup>
          )}

          {detailEnabled && bid.priorityNotes && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Priority Notes
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {bid.priorityNotes}
              </FormControl.Static>
            </FormGroup>
          )}
        </div>
      </div>
    </div>
  );
};

export default Bid;
